import React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';
import EDStandardSelect from '../../../../../../../../../../../../BaseComponents/Selects/StandardSelect/EDStandardSelect';

const styles = (theme: Theme) => ({
  hidden: {
    visibility: 'hidden',
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: theme.spacing(18),
  },
});

interface IProps {
  hidden: boolean;
  classes?: any;
}

const values = [
  { value: 0, displayLabel: 'Period' },
  { value: 1, displayLabel: 'Datum' },
];

class EkonomiskAnalysEditColumnTimeIntervalField extends React.Component<IProps> {
  render() {
    return (
      <Field name="timeInterval">
        {({ value, onChange }) => (
          <EDStandardSelect
            label="Tidsintervall"
            value={value || 0}
            items={values.map(value => ({
              header: value.displayLabel,
              value: value.value,
            }))}
            onChange={onChange}
            formControlRoot={classNames(this.props.classes.formControl, {
              [this.props.classes.hidden]: this.props.hidden,
            })}
            fullWidth={false}
            shrink
            tooltip="Tidsintervall"
          />
        )}
      </Field>
    );
  }
}

export default withStyles(EkonomiskAnalysEditColumnTimeIntervalField, styles);
